import React, { lazy, Suspense } from "react";
import { importMDX } from "mdx.macro";

import { useTranslation } from "react-i18next";

import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";

// Have to do this because dynamics path don't seem to work with importMDX.

const getContent = (language) => {
  switch (language) {
    case "en":
      return <EnContent />;
    case "pt":
      return <PtContent />;
    default:
      return <EsContent />;
  }
};

const EnContent = lazy(() => importMDX("./en.mdx"));
const EsContent = lazy(() => importMDX("./es.mdx"));
const PtContent = lazy(() => importMDX("./pt.mdx"));

export default function Methodology() {
  const { i18n } = useTranslation();

  return (
    <div style={{ width: "100%", backgroundColor: "lightgray" }}>
      <Suspense fallback={<div>Loading...</div>}>
        <div
          style={{
            width: "100%",
            backgroundColor: "lightgray",
          }}
        >
          <Container style={{ width: "100%", height: "100%" }}>
            <Box p={3}>
              <Paper style={{ width: "100%", padding: 45 }}>
                {getContent(i18n.language)}
              </Paper>
            </Box>
          </Container>
        </div>
      </Suspense>
    </div>
  );
}
